import React from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'

class HeroBannerNew extends React.Component {
  render() {
    const {
      title,
      slug,
      category,
      heroImage,
      heroImageTablet,
      heroImageMobile,
      readTime,
      pathname,
      typename,
    } = this.props
    const isArticlePage = this.props.pathname.indexOf('/article') === 0

    // grab images from Contentful. Desktop is only required one and so it's the fallback
    // if any other images are missing
    const desktopImg = heroImage ? heroImage.file.url : null
    const tabletImg = heroImageTablet
      ? heroImageTablet.file.url
      : heroImage.file.url
    const mobileImg = heroImageMobile
      ? heroImageMobile.file.url
      : heroImage.file.url

    // const categoryTitle = this.props.category
    //   ? this.props.category.title
    //   : this.props.featuredPage.title

    const heroClasses = classNames({
      'hero-banner': true,
    })
    return (
      <div className={heroClasses}>
        <div className="article__hero-image article__hero-image--lg">
          <div
            className="article__hero-image-background"
            style={{
              backgroundImage: `url("${desktopImg}?fm=jpg&q=90")`,
            }}
          />
        </div>
        <div className="article__hero-image article__hero-image--md">
          <div
            className="article__hero-image-background"
            style={{
              backgroundImage: `url("${tabletImg}?fm=jpg&q=90")`,
            }}
          />
        </div>
        <div className="article__hero-image article__hero-image--sm">
          <div
            className="article__hero-image-background"
            style={{
              backgroundImage: `url("${mobileImg}?fm=jpg&q=90")`,
            }}
          />
        </div>
        {/*<div className="article__gradient-whole" />*/}
        <div className="article__gradient-top" />
        <div className="article__gradient-bottom" />

        <div className="article__hero-content">
          <div className="article__hero-content-block block">
            <div className="article__date-category">
              <span>{category}</span>
            </div>
            {pathname.indexOf('/articles') === -1 ? (
              <Link
                to={
                  typename === 'ContentfulPageArticle'
                    ? `/articles/${slug}/`
                    : `/${slug}/`
                }
                title={title}
              >
                <div className="article__title">
                  <h1>{title}</h1>
                </div>
              </Link>
            ) : (
              <div className="article__title">
                <h1>{title}</h1>
              </div>
            )}
            {!isArticlePage && (
              <Link
                to={
                  typename === 'ContentfulPageArticle'
                    ? `/articles/${slug}/`
                    : `/${slug}/`
                }
                className="button button__transparent"
                title={title}
              >
                Read More
              </Link>
            )}
            {isArticlePage && (
              <div className="article__read-time">{readTime}</div>
            )}
          </div>
        </div>
      </div>
    )
  }
}
export default HeroBannerNew
